import { GameStats, DifficultySettings } from '../types';

export const exportToCSV = (data: GameStats[]) => {
    const headers = ['Timestamp', 'Accuracy', 'Time (seconds)', 'Score', 'Difficulty'];
    const csvContent = [
        headers.join(','),
        ...data.map(stat => [
            stat.timestamp,
            stat.accuracy.toFixed(2),
            stat.timeSeconds,
            stat.score,
            stat.difficulty
        ].join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `memory_game_results_${new Date().toISOString().slice(0,10)}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

/**
 * Legacy difficulty calculator - kept for backward compatibility
 * @deprecated Use adjustDifficulty from dda.ts instead
 */
export const calculateDynamicDifficulty = (history: GameStats[]): number => {
    if (history.length === 0) return 1;
    
    // Get the last 3 games or all if less than 3
    const recentGames = history.slice(-3);
    const averageAccuracy = recentGames.reduce((sum, game) => sum + game.accuracy, 0) / recentGames.length;
    
    // DDA Logic:
    // - If average accuracy > 80%, increase difficulty
    // - If average accuracy < 40%, decrease difficulty
    // - Otherwise maintain current difficulty
    if (averageAccuracy > 80) {
        return Math.min(10, recentGames[recentGames.length - 1].difficulty + 1);
    } else if (averageAccuracy < 40) {
        return Math.max(1, recentGames[recentGames.length - 1].difficulty - 1);
    }
    
    return recentGames[recentGames.length - 1].difficulty;
};

/**
 * Convert difficulty settings to a simple 1-10 level number
 * Used for backward compatibility with old difficulty system
 */
export const settingsToLevel = (settings: DifficultySettings): number => {
    // Simple mapping based on object count and grid size
    const objectScore = Math.min(5, Math.floor(settings.objectCount / 2));
    const gridScore = Math.min(3, settings.gridSize - 3);
    const timeScore = settings.memorizationTime < 10 ? 2 : settings.memorizationTime < 15 ? 1 : 0;
    
    return Math.max(1, Math.min(10, objectScore + gridScore + timeScore));
};